import React, {useEffect, useState} from 'react';

import {
    useResidenceExplorerStore,
    selectCurrentSunStudy,
    selectResidenceExplorerSettings,
    selectSetup,
    selectSunStudyFrame,
    selectSunStudyStarted,
} from 'features/residenceExplorer/store/useResidenceExplorerStore';
import {ImageSizes} from '@organisms/Shell/image-size-enum';
import {getImageUrlFromCDN} from '@atoms/Media/AsyncImage/helper';

import './_residenceExplorerSunStudyView.scss';

import {AsyncImage} from '@atoms/Media/AsyncImage';


export const ResidenceExplorerSunStudyView: React.FC = () => {
    const settings = useResidenceExplorerStore(selectResidenceExplorerSettings);
    const setup = useResidenceExplorerStore(selectSetup);
    const currentSunStudy = useResidenceExplorerStore(selectCurrentSunStudy);
    const sunStudyStarted = useResidenceExplorerStore(selectSunStudyStarted);
    const sunStudyFrame = useResidenceExplorerStore(selectSunStudyFrame);
    const setSunStudyFrame = useResidenceExplorerStore(state => state.setSunStudyFrame);
    const [currentFrame, setCurrentFrame] = useState<number>(sunStudyFrame);

    useEffect(() => {
        if (!currentSunStudy) return;
        setCurrentFrame(currentSunStudy.startFrame);
    }, [currentSunStudy]);

    useEffect(() => {
        if (!sunStudyStarted || !currentSunStudy) return;

        const updateFrame = () => {
            setCurrentFrame(prevFrame =>
                prevFrame + 2 < currentSunStudy.imageCount ? prevFrame + 1 : 0
            );
        };

        const interval = setInterval(updateFrame, 500);
        return () => clearInterval(interval);
    }, [sunStudyStarted, currentSunStudy]);

    useEffect(() => {
        setSunStudyFrame(currentFrame);
    }, [currentFrame, setSunStudyFrame]);

    if (!setup || !settings || !currentSunStudy) return null;

    const { viewBoxHeight = 0, viewBoxWidth = 0 } = settings;

    const getSunStudyImage = (frame: number) => {
        const { stageId } = setup;
        const imageUrl = `/externalfiles/image/residenceexplorer/${stageId}/sun${currentSunStudy.localPath}/${currentSunStudy.files[frame]}`;

        return {
            url: imageUrl,
            orgHeight: viewBoxHeight,
            orgWidth: viewBoxWidth,
            ratio: viewBoxWidth / viewBoxHeight,
        };
    };

    return (
        <div className="residence-explorer-sun-study-view">
            <AsyncImage
                image={getSunStudyImage(sunStudyFrame)}
                quality={ImageSizes.SIZE_900}
                className="residence-explorer-sun-study-view__image residence-explorer-sun-study-view__image--current"
                alt="Sun study"
                fullWidth
                noCrop
            />

            <div className="residence-explorer-sun-study-view__load-bay">
                {currentSunStudy.files.map((image, index) => (
                    <img
                        src={getImageUrlFromCDN(getSunStudyImage(index), ImageSizes.SIZE_900, true)}
                        alt="Sun study"
                        key={`${currentSunStudy.localPath}-${index}`}
                        className="residence-explorer-sun-study-view__image"
                    />
                ))}
            </div>
        </div>
    );
};
